module.exports = __webpack_public_path__ + "img/notificacion_de_pago_details.5dfb5d88.svg";